import {
  GET_NEW_ORDERS,
  GET_ACCEPTED_ORDERS,
  GET_DELIVERY_PENDING_ORDERS,
  GET_DELIVERING_ORDERS,
  ACCEPTING_ORDER,
  REJECTING_ORDER,
  LOGOUT_SUCCESS,
  ASSIGN_ORDER,
  // ORDER_DELIVERING,
} from "../actions/Types";

const initialState = {
  newOrders: [],
  acceptedOrders: [],
  deliveringOrders: [],
  deliveryPendingOrders: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_DELIVERY_PENDING_ORDERS:
      return {
        ...state,
        deliveryPendingOrders: action.payload,
      };
    // case ORDER_DELIVERING:
    //   var changedOrder = null;
    //   var DeliverypendingOrders = [];
    //   state.deliveryPendingOrders.forEach((order) => {
    //     if (order._id === action.payload) {
    //       return (changedOrder = order);
    //     }
    //     DeliverypendingOrders.push(order);
    //   });
    //   return {
    //     ...state,
    //     deliveryPendingOrders: DeliverypendingOrders,
    //     deliveringOrders: [...state.deliveringOrders, changedOrder],
    //   };
    case GET_NEW_ORDERS:
      return {
        ...state,
        newOrders: action.payload,
      };
    case ASSIGN_ORDER:
      var AcceptedOrder = [];
      var DeliveryPendingOrders = [];
      state.acceptedOrders.forEach((order) => {
        if (order._id === action.payload) {
          return DeliveryPendingOrders.push(order);
        }
        AcceptedOrder.push(order);
      });
      return {
        ...state,
        acceptedOrders: AcceptedOrder,
        deliveryPendingOrders: DeliveryPendingOrders,
      };

    case GET_ACCEPTED_ORDERS:
      return {
        ...state,
        acceptedOrders: action.payload,
      };
    case GET_DELIVERING_ORDERS:
      return {
        ...state,
        deliveringOrders: action.payload,
      };
    case ACCEPTING_ORDER:
      var acceptedOrders;
      var NewOrders = state.newOrders.filter(function (order) {
        if (order._id === action.payload.orderID) {
          acceptedOrders = [
            ...state.acceptedOrders,
            { ...order, preparationTime: action.payload.preparationTime },
          ];
        } else {
          return order._id !== action.payload.orderID;
        }
      });
      return {
        ...state,
        acceptedOrders,
        newOrders: NewOrders,
      };
    case REJECTING_ORDER:
      var AcceptedOrders;
      var NewOrders = state.newOrders.filter(function (order) {
        if (order._id === action.payload.orderID) {
          AcceptedOrders = [
            ...state.acceptedOrders,
            { ...order, preparationTime: action.payload.preparationTime },
          ];
        } else {
          return order._id !== action.payload.orderID;
        }
      });
      return {
        ...state,
        acceptedOrders: AcceptedOrders,
        newOrders: NewOrders,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        newOrders: [],
        acceptedOrders: [],
        deliveringOrders: [],
        deliveryPendingOrders: [],
      };
    default:
      return state;
  }
}
